import React, { useState } from "react";
import Helmet from "react-helmet";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";
import { ReturnToTop } from "./Button/Button";
import Notification from "./Notification/Notification";

const Layout = (props) => {
  const [childrenWithProps] = useState(undefined);
  const { children } = props;
  return (
    <>
      <Helmet 
      title={`${props.title ? (props.title + " - ") : ""}Sara Lee Deli`} 
      meta={[{ name: "description", content: props.description }]}
      />
      <Header/>
      {childrenWithProps ?? children}
      <ReturnToTop />
      <Footer />
      <Notification />
    </>
  );
};

export default Layout;
